import { render, staticRenderFns } from "./LicensedCandidates.vue?vue&type=template&id=26956aa4&"
import script from "./LicensedCandidates.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LicensedCandidates.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports